import { render, staticRenderFns } from "./BackerCenterRecentlyViewedProjectsSection.vue?vue&type=template&id=4047d30e"
import script from "./BackerCenterRecentlyViewedProjectsSection.vue?vue&type=script&lang=js"
export * from "./BackerCenterRecentlyViewedProjectsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports